
















































































import {
  Vue,
  Component
} from "@/shared/vuepack";
import {
  FieldFlagsBag,
  Validator
} from "vee-validate";
import { useDebitCardManagementStore } from "@/shared/store/debitCardManagement";
import { DebitCardManagerModalViewState } from "@/shared/types";
import { useThemeStore } from "@/shared/store/theme";

@Component({
    components: {}
})
export default class UpdatePinForm extends Vue {
    $validator: Validator;
    fields: FieldFlagsBag;
    debitCardManagementStore = useDebitCardManagementStore();
    themeStore = useThemeStore();

    oldPin = "";
    pin = "";
    confirmPin = "";
    userHasTouchedOldPinInput = false;
    userHasTouchedPinInput = false;
    userHasTouchedConfirmPinInput = false;
    formIsBeingSubmitted = false;

    get isContinueDisabled (): boolean {
        return this.errors.any() || (! this.pin);
    }

    onSubmitChanges (e: Event) {
        e.preventDefault();
        this.pinInputBlurred();
        this.pinConfirmInputBlurred();

        this.$validator.validateAll()
            .then(isValid => {
                if (this.formIsBeingSubmitted || !isValid) {
                    return;
                } else if (this.pin !== this.confirmPin) {
                    this.debitCardManagementStore.setModalState(DebitCardManagerModalViewState.PinsNotMatchingForm);
                    return;
                } else if (this.pin === this.oldPin) {
                    this.debitCardManagementStore.setModalState(DebitCardManagerModalViewState.PinsMatchingPreviousForm);
                    return;
                }

                this.formIsBeingSubmitted = true;
                this.changePin();
            });
    }

    changePin () {
        this.debitCardManagementStore.setFocusedCardPin(
            {
                oldPin: this.oldPin,
                pin: this.pin
            })
        .then(() => {
            this.debitCardManagementStore.setModalState(DebitCardManagerModalViewState.PinSetCompleteForm);
        })
        .catch(() => {
            this.formIsBeingSubmitted = false;
        });
    }

    oldPinInputBlurred () {
        this.$validator.validateAll();
        this.userHasTouchedOldPinInput = true;
    }

    validateOldPinState (ref) {
        if (this.userHasTouchedOldPinInput) {
            return !this.errors.has(ref);
        }
        return null;
    }

    pinInputBlurred () {
        this.$validator.validateAll();
        this.userHasTouchedPinInput = true;
    }

    validatePinState (ref) {
        if (this.userHasTouchedPinInput) {
            return !this.errors.has(ref);
        }
        return null;
    }

    pinConfirmInputBlurred () {
        this.$validator.validateAll();
        this.userHasTouchedConfirmPinInput = true;
    }

    validateConfirmPinState (ref) {
        if (this.userHasTouchedConfirmPinInput) {
            return !this.errors.has(ref);
        }
        return null;
    }

    togglePasswordMask (inputId: string) {
        const passwordField = document.getElementById(inputId);

        if (passwordField.getAttribute("type") === "password") {
            passwordField.setAttribute("type", "text");
        } else {
            passwordField.setAttribute("type", "password");
        }
    }
}
